import { render, staticRenderFns } from "./FancyDialog.vue?vue&type=template&id=3cc4fdd2&"
import script from "./FancyDialog.vue?vue&type=script&lang=js&"
export * from "./FancyDialog.vue?vue&type=script&lang=js&"
import style0 from "./FancyDialog.vue?vue&type=style&index=0&id=3cc4fdd2&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports